export default {"src":"/_next/static/media/BLFlag.1066d742.svg","height":480,"width":640};